import React from "react";

type ProfilesProps = {
  name: string;
  age: number;
  imageSrc: string;
  diagnosis: string;
  description: string;
};

const ProfilesMenu: React.FC<ProfilesProps> = ({
  name,
  age,
  imageSrc,
  diagnosis,
  description,
}) => {
  return (
    <div
      id={name}
      className="relative bg-sky-900 rounded-2xl h-full w-full p-4"
    >
      <div className="relative w-full h-full rounded-2xl overflow-hidden">
        <div className="absolute z-20 inset-0 bg-profile-cards"></div>
        <img
          src={imageSrc}
          className="relative w-full h-full object-cover"
        />
      </div>

      <section
        id="header"
        className="absolute w-full h-10 top-10 left-0 flex justify-between items-center pr-4 z-20"
      >
        <div className="absolute left-[-15px] top-[-10px] w-4 h-4 bg-[#ae902d] clip-arrow-top rotate-90"></div>
        <div className="clip-arrow bg-yellow-gradient w-11/12 h-full absolute left-[-15px] flex justify-between items-center pl-10 pr-6 z-30">
          <h2 className="text-profilesColor text-profileSize capitalize font-black font-avenir">
            {name}
          </h2>
          <h2 className="text-profilesColor text-sm font-black font-avenir">
            {age} years old
          </h2>
        </div>
      </section>
      <section
        id="footer"
        className="absolute bottom-0 h-1/3 w-full px-4 py-8 z-20 flex flex-col justify-end"
      >
        <div className="border-2 border-[#ffce0e] rounded-full w-fit h-auto">
          <p className="text-[#ffce0e] text-[12px] font-black py-2 px-6 font-avenir">
            {diagnosis}
          </p>
        </div>
        {/* <p className="w-[60%] text-left text-sm italic text-white">
          "{description}"
        </p> */}
      </section>
    </div>
  );
};

export default ProfilesMenu;
